module.exports = __webpack_public_path__ + "static/img/index.5a1f7441.png";